<!-- 查询计费接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          "parkCode": "2KNROS88",
          "carCodeArray": [
            "粤EQ2673"
          ],
          "newCardCodeArray": [],
          "grantTime": 20191120000000,
          "traderCode": "4639",
          "traderCouponGrantSn": "9NAZE0P1O4333",
          "traderCouponTemplate": {
            "blanceType": 0,
            "code": "GDG63O1LMADU",
            "couponType": 0,
            "faceValue": "0",
            "isCover": false,
            "maxCoverNum": 1,
            "name": "销售部-01",
            "originalPrice": 0,
            "realPrice": 0,
            "sellBillId": 1000222423,
            "useRule": "0<=${money}&&${money}<=9999"
          },
          "traderName": "测试 -1",
          "validFrom": 20191120000000,
          "validTo": 20191120235959
        },
        responseCode: {
          "data": {}, "message": "业务成功", "resultCode": 0, "status": 1
        },
        infoData: {
          explain: "智慧停车开放平台主动请求第三方接入系统下发商家券到停车场",
          flow: "/static/img/thirdTraderCoupon.svg",
          sdkcondition: "cmd=sendTraderCouponForThi",
          httpcondition: this.commonUrls.third + "sendTraderCouponForThi",
          precondition: "无",
          fitSystem: "第三方停车场",
          pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
          frequency: "实时触发",
          Q_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号'},
              {info1: 'traderCouponGrantSn', info2: '是', info3: 'String', info4: '券编码'},
              {info1: 'traderCouponTemplate', info2: '是', info3: 'JSONObject', info4: '券模板，详见traderCouponTemplate解释'},
              {info1: 'validFrom', info2: '是', info3: 'String', info4: '有效期开始时间，格式：yyyyMMddHHmmss'},
              {info1: 'validTo', info2: '是', info3: 'String', info4: '有效期结束时间，格式：yyyyMMddHHmmss'},
              {info1: 'carCodeArray', info2: '是', info3: 'String[]', info4: '车牌数组'},
              {info1: 'traderName', info2: '是', info3: 'String', info4: '商家名称'},
              {info1: 'traderCode', info2: '是', info3: 'String', info4: '商家编码'},
              {info1: 'grantTime', info2: '是', info3: 'String', info4: '发放时间，格式：yyyyMMddHHmmss'},
              {info1: 'cardCodeArray', info2: '否', info3: 'String[]', info4: '卡号数组'}
            ]
          }, {
            titleName: 'traderCouponTemplate',
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'id', info2: '否', info3: 'Long', info4: '券模板编号'},
              {info1: 'code', info2: '是', info3: 'String', info4: '券模板代码'},
              {info1: 'name', info2: '是', info3: 'String', info4: '券名称'},
              {info1: 'blanceType', info2: '是', info3: 'Integer', info4: '结算类型；0：销售结算，1：发放结算，2：使用结算'},
              {
                info1: 'couponType',
                info2: '是',
                info3: 'Integer',
                info4: '券类型(0:免费券,1:金额扣减券,车费减免固定金额结算,2:金额折扣券,车费折扣减免结算,3:金额固定值券,车费按券的固定值结算,4:时间券,时间减免后再按车费结算,5:不同计价券,按不同计价规则车费结算)'
              },
              {
                info1: 'faceValue',
                info2: '是',
                info3: 'String',
                info4: '免费券:默认0；金额扣减券:为大于0的正数且保留2位小数；金额折扣券:为0-1且保留2位小数；金额固定券:为大于0的正数且保留2位小数；时间券:为大于0的整数 说明:金额相关的券都以元为单位，时间券以分为单位'
              },
              {info1: 'originalPrice', info2: '是', info3: 'BigDecimal(7,2)', info4: '原价'},
              {info1: 'realPrice', info2: '否', info3: 'BigDecimal(7,2)', info4: '折扣价'},
              {info1: 'useRule', info2: '否', info3: 'String', info4: '使用规则，0<=${money}&&${money}<=100表示0~100元内可用'},
              {info1: 'isCover', info2: '否', info3: 'Boolean', info4: '是否支持叠加使用'},
              {info1: 'maxCoverNum', info2: '否', info3: 'Integer', info4: '最大叠加数'},
              {info1: 'remark', info2: '否', info3: 'String', info4: '券描述'},
              {info1: 'sellBillId', info2: '否', info3: 'Long', info4: '销售ID'},
              {info1: 'extraProperty', info2: '否', info3: 'String', info4: '劵额外属性，JSON字符串'}
            ]
          }, {
            titleName: 'extraProperty，当券为时间券时',
            tabledata: [{tableHead: '扣减规则', tdName: 'info1'}, {
              tableHead: '优惠后有无免费时长',
              tdName: 'info2'
            }, {tableHead: '计费说明', tdName: 'info3'}, {tableHead: 'extraProperty', tdName: 'info4'}, {
              tableHead: '图解',
              tdName: 'image'
            }],
            td: [
              {
                info1: '扣减前面时间',
                info2: '有',
                info3: '默认；优惠后金额：将进场时间往后推时间券面值得到新计费起始时间，新计费起始时间和计费结束时间按计费规则计费得到优惠后金额；优惠金额：正常计费金额-优惠后金额',
                info4: '{"free":"0","rule":"0"}',
                image: '/static/img/扣减前面时间按优惠后有免费时长.png'
              },
              {
                info1: '扣减前面时间',
                info2: '无',
                info3: '优惠后金额：将进场时间往后推时间券面值得到新计费起始时间，新计费起始时间和计费结束时间按去掉免费时长的计费规则计费得到优惠后金额；优惠金额：正常计费金额-优惠后金额',
                info4: '{"free":"1","rule":"0"}',
                image: '/static/img/扣减前面时间.png'
              },
              {
                info1: '扣减后面时间',
                info2: '有',
                info3: '优惠后金额：将计费结束时间往前推时间券面值得到新计费结束时间，进场时间和新计费结束时间按计费规则计费得到优惠后金额；优惠金额：正常计费金额-优惠后金额',
                info4: '{"free":"0","rule":"1"}',
                image: '/static/img/扣减后面时间有免费时长.png'
              },
              {
                info1: '扣减后面时间',
                info2: '无',
                info3: '优惠后金额：将计费结束时间往前推时间券面值得到新计费结束时间，进场时间和新计费结束时间按去掉免费时长的计费规则计费得到优惠后金额；优惠金额：正常计费金额-优惠后金额',
                info4: '{"free":"1","rule":"1"}',
                image: '/static/img/扣减后面时间.png'
              },
              {
                info1: '扣减进场时间和优惠时间计算的金额',
                info2: '无',
                info3: '优惠金额：进场时间和计费结束时间（进场时间+优惠券面值）按计费规则计算得到优惠金额；优惠后金额：正常计费金额-优惠金额',
                info4: '{"free":"0","rule":"2"}',
                image: '/static/img/扣减进场时间和优惠时间计算的金额.png'
              },
              {
                info1: '扣减优惠时间和计费结束时间计算的金额',
                info2: '无',
                info3: '优惠金额：计费起始时间（计费结束时间-优惠券面值）和计费结束时间按计费规则计算得到优惠金额；优惠后金额：正常计费金额-优惠金额',
                info4: '{"free":"0","rule":"3"}',
                image: '/static/img/扣减优惠时间和结束时间计算的金额.png'
              }
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: []
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{tableHead: '状态码', tdName: 'info1'}, {tableHead: '说明', tdName: 'info2'}],
            td: [{info1: '000110', info2: '失败',}, {info1: '00110000', info2: '失败',}, {info1: '110000', info2: '失败',}]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/thirdParkForAke/common/sendTraderCouponForThi.vue